import { ReactNode, useState } from 'react';
import { Tab, Tabs } from '@ui/components/Tabs';
import { AnimationCrossfade } from '@ui/components/AnimationCrossfade';

import styles from './ClubAdmin.module.css';

type Props = {
  details: ReactNode;
  managers: ReactNode;
};

type ClubAdminTab = 'details' | 'managers';

const TABS: Tab<ClubAdminTab>[] = [
  {
    label: 'Данные клуба',
    value: 'details',
  },
  {
    label: 'Менеджеры клуба',
    value: 'managers',
  },
];

export function ClubAdmin({ details, managers }: Props) {
  const [tab, setTab] = useState<ClubAdminTab>('details');
  return (
    <div className={styles.root}>
      <Tabs
        className={styles.tabs}
        tabs={TABS}
        value={tab}
        onChange={setTab}
      />

      <AnimationCrossfade contentKey={tab}>
        { tab === 'details' && details }
        { tab === 'managers' && managers }
      </AnimationCrossfade>
    </div>
  );
}
